import { format } from 'date-fns';

export const convertLocalTime = (time) =>
  new Date(format(new Date(`${time}Z`), 'MM/dd/yyyy HH:mm:ss'));
